<template>
<div>

  <v-card>
    <v-card-title>
      {{titulo}}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fas fa-search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-container>
        <v-row>
          
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="id_customer"
              :items="customers"
              item-text="nombre"
              item-value="codigo"
              label="Escoge un Productor"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="id_coffee"
              :items="types"
              item-text="nombre"
              item-value="codigo"
              label="Escoge la clase de Café"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col>

          <!-- <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="id_place"
              :items="places"
              item-text="name"
              item-value="id"
              label="Escoge la ubicación"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col> -->

          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="user"
              :items="lotFilterOptions"
              label="Escoge el Usuario"
              clearable
              rounded
              solo
              hide-details
            ></v-autocomplete>
          </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value="dates"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeText"
                label="Filtrar por fecha"
                prepend-icon="fa-calendar-alt"
                readonly
                filled
                rounded
                clearable
                hide-details
                :disabled="loading"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              range
              :title-date-format="title"
              scrollable
              :max="today"
            >
              <v-row no-gutters style="flex-wrap: nowrap;">
                <v-btn
                  class="flex-grow-1 flex-shrink-0"
                  large
                  rounded
                  outlined
                  color="primary"
                  @click="modal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  class="flex-grow-1 flex-shrink-0"
                  large
                  rounded
                  color="primary"
                  @click="
                    $refs.dialog.save(dates);
                    updateDateFilter();
                  "
                  >Aceptar</v-btn
                >
              </v-row>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="organic"
              :items="[{ text: 'Orgánico', value: 1 }, { text: 'Convencional', value: 0 }]"
              label="Tipo de Producción"
              clearable
              rounded
              solo
              hide-details
            ></v-select>
          </v-col>

        <v-col cols="12" sm="12" md="2">
            <v-btn
              color="success"
              class="ma-2 white--text"
              @click="getByCustomer"
              block
            >
              Filtrar <v-icon right >
                fas fa-filter
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="warning"
              class="ma-2 white--text"
              @click="getAll"
              block
            >
              Ver Todo
              <v-icon right >
                fas fa-eye
              </v-icon>
            </v-btn>
          </v-col>

        </v-row>
    </v-container>

    <v-data-table
      :headers="headers"
      :items="currentItems"
      :search="search"
      sort-by="date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Consultando datos... Espere por favor"
    >
    <template v-slot:[`item.date`]="{ item }">
        {{ dateFormat(item.date) }}
    </template>
    <template v-slot:[`item.precio`]="{ item }">
        {{ item.precio != null ? numberWithCommas(item.precio) : '' }}
    </template>
    <template v-slot:[`item.cost`]="{ item }">
        {{ item.cost != null ? numberWithCommas(item.cost) : '' }}
    </template>

    <template slot="body.append">
      <tr class="gray--text">
        <!-- <th class="title"></th> -->
        
        <th colspan="8" class="title">
        <v-row class="pt-2">
          <v-col cols="12" sm="12" md="4">
            Total: {{ numberWithCommas((parseFloat(sumField('cost'))).toFixed(2)) }}
          </v-col>
          <v-col cols="12" sm="12" md="4">
            Compra: {{ numberWithCommas((parseFloat(sumField('total_buy'))).toFixed(2)) }}
          </v-col>
          <v-col cols="12" sm="12" md="4">
            Deposito: {{ numberWithCommas((parseFloat(sumField('total_deposit'))).toFixed(2)) }}
          </v-col>
        </v-row>
        </th>
        
      </tr>
    </template>
    </v-data-table>
  </v-card>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import * as moment from 'moment';

export default {
  name: "reception",
  data: () => ({
    currentItems: [],
    samplings: [],
    customers: [],
    types: [],
    places: [],
    dates: [],
    id_customer: null,
    lotFilterOptions: [],
    id_coffee: null,
    id_place: null,
    organic: null,
    user: null,
    loading: false,
    dialogDelete: false,
    loader: null,
    loading3: false,
    modal: false,
    search: "",
    loading: false,
    titulo: "Recepción de Café",
    headers: [
      { text: "Fecha", align: "left", value: "date"},
      { text: "Productor", align: "left", value: "nombre" },
      { text: "Clase de Café", align: "left", value: "product" },
      { text: "Compra", value: "total_buy" },
      { text: "Depósito", value: "total_deposit" },
      { text: "Precio", value: "precio" },
      { text: "Nota de Peso", value: "code" },
      { text: "Usuario", value: "user" },
    ],
  }),

  computed: {
    
    ...mapState(["db","headers_db"]),
    dateRangeText: {
        get()
        {
            return this.dates.join(' ~ ')
        },
        set()
        {
            this.dates = []
        }
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 1000)

        this.loader = null
    },
  },

  methods: {
    ...mapActions(["validateSession"]),
    // Metodos base de datos
    async getSamplings(){
      await axios.get(this.db + 'reception',
        {
          headers: this.headers_db
        }).then(response => {
          this.samplings = this.currentItems = response.data.data;
          this.currentItems.forEach(item => {
            item.cost = ((parseFloat(item.total_deposit) + parseFloat(item.total_buy))).toFixed(2);
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getSamplings(); })
        });
    },

    async getCustomers(){
      await axios.get(this.db + 'providers',
        {
          headers: this.headers_db
        }).then(response => {
          this.customers = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getCustomers(); })
        });
    },

    async getTypes(){
      await axios.get(this.db + 'types',
        {
          headers: this.headers_db
        }).then(response => {
          this.types = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getTypes(); })
        });
    },

    async getPlaces(){
      await axios.get(this.db + 'places',
        {
          headers: this.headers_db
        }).then(response => {
          this.places = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getPlaces(); })
        });
    },

    deleteItem(item) {
      console.log(item);
      this.item.id = item.id;
      this.item.id_cxp = item.id_cxp;
      this.item.customer = item.nombre;
      this.item.productor = item.nomprov;
      this.item.nota = item.coddoc;
      this.item.quantity = item.cant;
      this.dialogDelete = true;
    },

    deleteRetention(item){
      axios.post(this.db + 'retention/delete', 
      {
        id: item.id,
        id_cxp: item.id_cxp
      },
      {
        headers: this.headers_db
      })
      .then((response) => {
        console.log(response);
        this.samplings = this.samplings.filter(doc => {
              return doc.id != item.id
        })
        this.currentItems = this.samplings;
      })
      .catch((error) => {
        console.log(error);
        this.validateSession(error).then((resp) => { if(resp) this.deleteRetention(item); })
      });

    },
    // FIN Metodos base de datos

    // Metodos Generales
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY hh:mm a');
    },
    title() {
      return "Selecciona las fechas a filtrar";
    },
    updateDateFilter() {
      if (this.dates.length > 1) {
        if (moment(this.dates[0], "YYYY-MM-DD") > new Date(this.dates[1])) {
          this.dates = [this.dates[1], this.dates[0]];
        }
      } else {
        this.dates = [this.dates[0], this.dates[0]];
      }
    },

    getUniqueLots() {
      // Obtén los valores únicos de la columna "age" de tus datos
      const uniqueLots = [...new Set(this.currentItems.map(item => item.user))];
      console.log(uniqueLots);
      return uniqueLots;
    },

    close() {
      this.dialogDelete = false;
    },
    sumField(key) {
      return this.currentItems.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },

    getByCustomer() {
      console.log('dates', this.dates, this.id_coffee, this.organic, this.id_customer);

      // PLACE
      if (this.id_place && this.id_customer && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_productor == this.id_customer && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      if (this.id_place && this.user && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.user == this.user && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }
      
      else if (this.id_place && this.id_customer && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee && doc.id_productor == this.id_customer;
        });
      }

      else if (this.id_place && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      // CUSTOMER
      else if (this.id_coffee && this.id_customer && this.organic != undefined) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_tipo_producto == this.id_coffee && doc.id_productor == this.id_customer && parseInt(doc.organic) === parseInt(this.organic);
        });
      }
      
      else if (this.id_customer && this.dates[0] && this.dates[1] && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return doc.id_productor == this.id_customer && doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_customer && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return doc.id_productor == this.id_customer && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_coffee && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return doc.id_tipo_producto == this.id_coffee && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_place && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return parseInt(doc.id_place) == parseInt(this.id_place) && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.user && this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return doc.user == this.user && date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }

      else if (this.id_coffee && this.id_customer) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_tipo_producto == this.id_coffee && doc.id_productor == this.id_customer;
        });
      }
      
      else if (this.id_coffee && this.organic != undefined) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_tipo_producto == this.id_coffee && parseInt(doc.organic) === parseInt(this.organic);
        });
      }

      else if (this.organic != undefined && this.id_customer) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.organic) === parseInt(this.organic) && doc.id_productor == this.id_customer;
        });
      }

      else if (this.id_place && this.id_customer) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_productor == this.id_customer;
        });
      }


      else if (this.id_place && this.user) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.user == this.user;
        });
      }

      else if (this.id_place && this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place) && doc.id_tipo_producto == this.id_coffee;
        });
      }
      
      else if (this.id_customer) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_productor == this.id_customer;
        });
      }

      else if (this.user) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.user == this.user;
        });
      }

      else if (this.id_coffee) {
        this.currentItems = this.samplings.filter(doc => {
          return doc.id_tipo_producto == this.id_coffee;
        });
      }

      else if (this.id_place) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.id_place) == parseInt(this.id_place);
        });
      }

      else if (this.organic != undefined) {
        this.currentItems = this.samplings.filter(doc => {
          return parseInt(doc.organic) === parseInt(this.organic);
        });
      }

      else if (this.dates[0] && this.dates[1]) {
        this.currentItems = this.samplings.filter(doc => {
          let date_db = moment(doc.date).format('YYYY-MM-DD');
          return date_db >= this.dates[0] && date_db <= this.dates[1];
        });
      }
      else {
        this.currentItems = this.samplings;
      }
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getAll() {
      this.loader = 'loading3'
      this.loading = true;
      this.getSamplings();
      this.getCustomers();
    },
    eliminar() {
      console.log(this.item.id);
      // return;
      this.deleteRetention(this.item);
      this.close();
    },
  },
  async mounted() {
    this.loading = true;
    await this.getTypes();
    await this.getPlaces();
    await this.getCustomers();
    await this.getSamplings();
    this.lotFilterOptions = this.getUniqueLots();
  },
};
</script>